import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

//-----------------------|| AUTH GUARD ||-----------------------//

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */

const AuthPermission = ({ children, contentList }) => {
    const account = useSelector((state) => state.account);
    const { permissions } = account;
    //console.log(children)
    if (permissions.includes(contentList) ) {
        console.log('permission granded')
        return children
    }

    return "";
};

AuthPermission.propTypes = {
    children: PropTypes.node
};

export default AuthPermission;
